import { useGenUiI18n } from '../../shared/ui/i18n.js';
import type { PlaceDetails, PlacesPort } from '@voll-intelligence/genui-contract';
import { PlaceFacts } from './place_facts.js';
import { PlacePhoto } from './place_photo.js';
export function SummaryCard({
  place,
  port,
  position,
  selected,
  onSelect,
  wide = false,
}: {
  readonly place: PlaceDetails;
  readonly port?: PlacesPort;
  readonly position: number;
  readonly selected: boolean;
  readonly onSelect: (placeId: string, opener: HTMLButtonElement) => void;
  /** Card sozinho na largura toda: a foto vai ao lado do texto a partir do `sm`. */
  readonly wide?: boolean;
}) {
  const { t } = useGenUiI18n();
  return (
    <article
      aria-label={place.name}
      aria-current={selected ? 'true' : undefined}
      className={`flex h-full flex-1 flex-col rounded-2xl border bg-card p-4 transition ${
        wide ? 'sm:flex-row sm:items-start sm:gap-4' : ''
      } ${selected ? 'border-primary' : 'border-border'}`}
    >
      {place.photos[0] && port && (
        <div
          className={`mb-4 overflow-hidden rounded-xl ${wide ? 'sm:mb-0 sm:w-56 sm:shrink-0' : ''}`}
        >
          <PlacePhoto photo={place.photos[0]} place={place} port={port} compact />
        </div>
      )}
      <div className="flex gap-3">
        <span
          aria-hidden
          className="grid size-7 shrink-0 place-items-center rounded-full bg-primary text-sm font-semibold text-primary-foreground"
        >
          {position}
        </span>
        <div className="min-w-0 flex-1">
          {place.primaryTypeDisplayName && (
            <p className="mb-1 text-xs font-medium uppercase tracking-wide text-muted-foreground">
              {place.primaryTypeDisplayName}
            </p>
          )}
          <h3 className="text-base font-semibold text-foreground">{place.name}</h3>
          <PlaceFacts place={place} />
          {place.address && <p className="mt-1 text-sm text-muted-foreground">{place.address}</p>}
          {/* Compacto para o trilho: UMA ação. "Como chegar" e a fonte do Google
              vivem na ficha, que é onde a leitura detalhada acontece. */}
          <div className="mt-3">
            <button
              type="button"
              aria-haspopup="dialog"
              aria-label={t('consultPlaces.details', { place: place.name })}
              className="rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground"
              onClick={(event) => {
                onSelect(place.placeId, event.currentTarget);
              }}
            >
              {t('consultPlaces.detailsShort')}
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}
